angular.module 'zc.commonApi'

.factory 'Meta', (Api, $q) ->

  factory = []

  _.each [
    "devices"
    "segments"
    "referrer_types"
    "project_campaign_statuses"
    "session_count_evaluators"
    "particular_event_page_types"
    "particular_event_names"
    "cart_price_page_types"
    "cart_button_page_types"
    "advertising_match_types"
    "newsletter_parameter_match_types"
    "login_evaluator_match_types"
    "login_evaluator_evaluation_types"
    "project_domain_link_types"
    "project_ranks"
    "product_lines"
    "currencies"
    "regions"
    "sales_entities"
    "campaign_segment_allowed_conditions"
    "page_types"
    "page_type_match_types"
    "trial_invoice_calculation_types"
    "incentive_discount_types"
    "contract_statuses"
    "shopping_cart_asps"
    "invoice_calculation_types"
    "payment_methods"
    "invoice_issue_days"
    "invoice_due_days"
    "invoice_payment_days"
    "invoice_payment_months"
    "services"
    "interest_widget"
    "interest_widget_templates"
    "badge_position_adjustment_devices"
    "pricing_types"
    "google_analytics_event_labels"
    "opt_targets"
    "configuration_types"
    "testing_units"
    "sampling_ranges"
    "lite_sampling_ranges"
    "country_codes"
  ], (meta) ->

    # project_campaign_statuses => ProjectCampaignStatuses
    camelized = _.upperFirst(_.camelCase(meta))

    factory["get#{camelized}"] = () ->
      d = $q.defer()
      Api.get "/api/meta/#{meta}"
      .then (res) ->
        if res.data.success
          d.resolve res.data[meta]
        else
          d.reject []

      d.promise

  factory



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/meta_service.js.coffee